const elementsToShow = document.querySelectorAll( '.animate' )

let scroll = window.requestAnimationFrame
let amountScrolled = 0

const body = document.body
const header = document.getElementById('siteHeader')
const scrollThreshold = 200

const init = function() {

  setTimeout( () => {
    loop()
    if ( header ) header.classList.add('is-initialized')
  }, 200 )

};

const loop = function() {
  watchForAnimationElements()
  updateHeaderClasses()
	scroll( loop )
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// FOR SCROLL TRANSITIONS
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const watchForAnimationElements = function() {

	elementsToShow.forEach( ( element ) => {
		const baseClass = 'animated';
		if ( isElementInViewport( element ) ) {
			if ( element.classList.contains( baseClass ) ) {
				return;
			}
			element.classList.add( baseClass );
		}
	});

}

// Fires repeatedly as the page is scrolled using request animation frame
const isElementInViewport = function( el ) {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// FOR HEADER VISIBILITY
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const updateHeaderClasses = function() {

  // wtoggle at-top class
  if ( amountScrolled <= 0 ) {
    body.classList.add('is-at-top')
  } else {
    body.classList.remove('is-at-top')
  }

  // toggle threshold class
	if ( getAmountscrolled() > scrollThreshold ) {
    body.classList.add('beyond-scroll-threshold')
	} else {
		body.classList.remove('beyond-scroll-threshold')
	}

}

const getAmountscrolled = function(){

	const pxScrolled = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
  
  if ( pxScrolled !== amountScrolled ) amountScrolled = pxScrolled
  
	return pxScrolled

}

const api = {
	init: init
};

export default api;